import type { FC } from "react";
import React from "react";
import loadable from "@loadable/component";
import type { ModalViewType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { COMPONENT_BUILDANDBUY } from "../../../../../../../shared-logic/server/components";
import type { IntegratedTradeInModalType } from "../../../../../../../shared-logic/features/tradein/utils/integratedModalConstants";
import TradeInAemModalWrapper from "./TradeInAemModalWrapper";

const IntegratedTradeInAem = loadable(async () => {
    const component = await import(
        /* webpackChunkName: "integrated-tradein-aem-lexus" */
        "../../../../../../../tradein/components/lexus/IntegratedTradeInAem"
    );
    return component.default;
});

// TODO: Should be moved to shared features folder
const IntegratedTradeInAemModal: FC<ModalViewType<IntegratedTradeInModalType>> = (props) => {
    const { close } = props;

    return (
        <TradeInAemModalWrapper closeModal={close}>
            <IntegratedTradeInAem parentComponent={COMPONENT_BUILDANDBUY} />
        </TradeInAemModalWrapper>
    );
};

export default IntegratedTradeInAemModal;
